import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {UserPreferencesModalComponent} from './user-preferences-modal.component';

@Injectable({
    providedIn: 'root'
})
export class UserPreferencesModalService extends ModalService {
    testModal() {
        this.createModalComponent(UserPreferencesModalComponent);
        this.showModalComponent();
    }
    showModal() {
        this.createModalComponent(UserPreferencesModalComponent);
        this.showModalComponent();
    }
}
